// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see OverdraftCoverageViewViewStatusEvent
 */
export var OverdraftCoverageViewViewStatus = function (_a) {
    var status = _a.status;
    return ({
        name: "OverdraftCoverage View ViewStatus",
        parameters: {
            cdf_entity: "OverdraftCoverage",
            cdf_action: "View",
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see OverdraftCoverageManageToggleEnabledEvent
 */
export var OverdraftCoverageManageToggleEnabled = function (_a) {
    var enabled = _a.enabled;
    return ({
        name: "OverdraftCoverage Manage ToggleEnabled",
        parameters: {
            cdf_entity: "OverdraftCoverage",
            cdf_action: "Manage",
            enabled: enabled !== undefined && enabled !== null ? enabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see OverdraftCoverageManageRepayEvent
 */
export var OverdraftCoverageManageRepay = function () { return ({
    name: "OverdraftCoverage Manage Repay",
    parameters: {
        cdf_entity: "OverdraftCoverage",
        cdf_action: "Manage",
    }
}); };
/**
 * @see OverdraftCoverageManageSetAmountEvent
 */
export var OverdraftCoverageManageSetAmount = function (_a) {
    var amount = _a.amount, currencyCode = _a.currencyCode;
    return ({
        name: "OverdraftCoverage Manage SetAmount",
        parameters: {
            cdf_entity: "OverdraftCoverage",
            cdf_action: "Manage",
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            currency_code: currencyCode !== undefined && currencyCode !== null ? currencyCode.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see OverdraftCoverageManageTapFooterEvent
 */
export var OverdraftCoverageManageTapFooter = function () { return ({
    name: "OverdraftCoverage Manage TapFooter",
    parameters: {
        cdf_entity: "OverdraftCoverage",
        cdf_action: "Manage",
    }
}); };
/**
 * @see OverdraftCoverageManageTapBalanceAppletTongueEvent
 */
export var OverdraftCoverageManageTapBalanceAppletTongue = function () { return ({
    name: "OverdraftCoverage Manage TapBalanceAppletTongue",
    parameters: {
        cdf_entity: "OverdraftCoverage",
        cdf_action: "Manage",
    }
}); };
/**
 * @see OverdraftCoverageManageTapBalanceHomeOverdraftCoverageItemEvent
 */
export var OverdraftCoverageManageTapBalanceHomeOverdraftCoverageItem = function () { return ({
    name: "OverdraftCoverage Manage TapBalanceHomeOverdraftCoverageItem",
    parameters: {
        cdf_entity: "OverdraftCoverage",
        cdf_action: "Manage",
    }
}); };
/**
 * @see OverdraftCoverageManageTapCardsTabOverdraftCoverageItemEvent
 */
export var OverdraftCoverageManageTapCardsTabOverdraftCoverageItem = function () { return ({
    name: "OverdraftCoverage Manage TapCardsTabOverdraftCoverageItem",
    parameters: {
        cdf_entity: "OverdraftCoverage",
        cdf_action: "Manage",
    }
}); };
